// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/billdodson/staging-csr-phone/frontend/src/models/avatarModel';
import model_2 from '/home/billdodson/staging-csr-phone/frontend/src/models/callModel';
import model_3 from '/home/billdodson/staging-csr-phone/frontend/src/models/csrModel';
import model_4 from '/home/billdodson/staging-csr-phone/frontend/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'avatarModel', model: model_1 },
model_2: { namespace: 'callModel', model: model_2 },
model_3: { namespace: 'csrModel', model: model_3 },
model_4: { namespace: '@@initialState', model: model_4 },
} as const
